import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ClockIcon, MapPinIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden border-b-[3px] border-noir bg-canard" data-id="element-144" data-mp="joymg3lvz859">
      <div aria-hidden="true" className="absolute inset-0 opacity-[0.18] stripes-canard" data-id="element-145" data-mp="eq549xvnmsyr" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-[1.05fr_0.95fr]" data-id="element-146" data-mp="aoa2ytdq4fkz">
        <div data-id="element-147" data-mp="5onu0w4xhlhz">
          <motion.span initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="inline-block -rotate-1 border-[3px] border-noir bg-rouge px-3 py-1 font-display text-xs uppercase tracking-[0.16em] text-creme" data-id="element-148" data-mp="5o5n95kn3ovt">
            Venez découvrir nos nouveautés
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-5 font-display text-5xl uppercase leading-[0.86] text-creme sm:text-6xl lg:text-7xl" data-id="element-149" data-mp="1q37l8u1o1kjg">
            Nos tourtes
            <br data-id="element-150" data-mp="1hwpxpzpkjyqe" />
            du <span className="text-jaune" data-id="element-151" data-mp="1hyatfsnmdnpu">monde</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.1,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-6 max-w-xl text-lg leading-relaxed text-creme/85" data-id="element-152" data-mp="25n3pdp48rvkg">
            Un produit d’ici avec des recettes de là-bas. Pâte pur beurre, garnitures
            mijotées le matin même, et un camion qui s’arrête juste au coin d’la rue.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.15,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-9 flex flex-wrap items-center gap-3" data-id="element-153" data-mp="2ojv89xfvg8nz">
            <Link to="/commander" className="inline-flex items-center gap-2 border-[3px] border-noir bg-jaune px-6 py-3.5 font-display text-base uppercase tracking-wide text-noir shadow-hard transition-transform duration-150 ease-out hover:-translate-y-1" data-id="element-154" data-mp="2yalkkf0j79vj">
              Commander en ligne
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-155" data-mp="2kbdlrn8a63rv" />
            </Link>
            <Link to="/traiteur" className="inline-flex items-center gap-2 border-[3px] border-creme px-6 py-3.5 font-display text-base uppercase tracking-wide text-creme transition-colors duration-150 ease-out hover:bg-creme hover:text-noir" data-id="element-156" data-mp="2fgpujglw6v9l">
              Traiteur événementiel
            </Link>
          </motion.div>

          <dl className="mt-10 flex flex-wrap gap-x-8 gap-y-3 border-t border-creme/25 pt-6 text-creme" data-id="element-157" data-mp="1wkzsjtdylyvp">
            <div className="flex items-center gap-2" data-id="element-158" data-mp="c14ci4iogdsz">
              <MapPinIcon className="h-4 w-4 text-jaune" aria-hidden="true" data-id="element-159" data-mp="h10l6h2bktev" />
              <dt className="sr-only" data-id="element-160" data-mp="h33h1hq5lgri">Aujourd’hui</dt>
              <dd className="text-sm font-semibold" data-id="element-161" data-mp="m14zq1jo3e2g">Aujourd’hui : Place du Marché</dd>
            </div>
            <div className="flex items-center gap-2" data-id="element-162" data-mp="q0nlt0n85v6v">
              <ClockIcon className="h-4 w-4 text-jaune" aria-hidden="true" data-id="element-163" data-mp="3pgslusgcgoxq" />
              <dt className="sr-only" data-id="element-164" data-mp="3pepkxddnlbe8">Horaires</dt>
              <dd className="text-sm font-semibold" data-id="element-165" data-mp="3uf3vp36n2zfy">11h30 – 14h00</dd>
            </div>
          </dl>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-166" data-mp="2b1jw5fgx1v6">
          <div className="relative border-[4px] border-noir bg-creme shadow-hard" data-id="element-167" data-mp="36o85ublquebc">
            <img src="https://cdn.magicpatterns.com/uploads/fFfdPrzf4ZAAM82UQE81hT/1000003465.jpg" alt="Tourte dorée faite maison servie avec une salade de jeunes pousses" className="h-[300px] w-full object-cover md:h-[440px]" data-id="element-168" data-mp="3aqcv6y55sos6" />
            <div className="flex items-center justify-between gap-3 border-t-[4px] border-noir bg-creme px-4 py-3" data-id="element-169" data-mp="31dw20fwdzvfh">
              <div data-id="element-170" data-mp="2wl2vpnl9sf1a">
                <p className="font-display text-lg uppercase leading-none" data-id="element-171" data-mp="2wkjde5rpjomq">La Buenos Aires</p>
                <p className="text-xs uppercase tracking-[0.12em] text-noir/60" data-id="element-172" data-mp="3afvfwzc3uje7">Argentine · bœuf, olives, cumin</p>
              </div>
              <span className="border-[3px] border-noir bg-jaune px-2.5 py-1 font-display text-lg leading-none" data-id="element-173" data-mp="3kci33urwlmje">9,50 €</span>
            </div>
          </div>
          <span className="absolute -left-3 -top-4 rotate-[-8deg] border-[3px] border-noir bg-jaune px-3 py-1 font-display text-xs uppercase tracking-[0.12em] shadow-hard-sm" data-id="element-174" data-mp="3faspq8h7kws5">
            Fait maison
          </span>
        </motion.div>
      </div>
    </section>;
}